import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Fade,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { format, parse } from 'date-fns';
import BeneficiarioApi from '../../api/BeneficiarioApi.js';
import GuiaApi from '../../api/GuiaApi.js';
import TipoAtendimentoApi from '../../api/TipoAtendimentoApi.js';
import { withAuditoria } from '../../contexts/AuditoriaContext.jsx';
import { withLoading } from '../../contexts/LoadingContext.jsx';
import { withSnackbar } from '../../contexts/SnackbarContext.jsx';

import ButtonAlertas from './ButtonAlertas.jsx';
import ButtonAnexos from './ButtonAnexos.jsx';
import ButtonGlosas from './ButtonGlosas.jsx';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import OpenInNew from '@material-ui/icons/OpenInNew';
import ButtonHistoricoGuia from './ButtonHistoricoGuia.jsx';
import MenuListGuia from './MenuListGuia.jsx';
import Utils from './Utils.js';

import { LinearProgress } from '@material-ui/core';
import CarenciaApi from '../../api/CarenciaApi.js';
import ElementoApi from '../../api/ElementoApi.js';
import AlertDialogSlide from './AlertDialogSlide.jsx';
import AlertDialogSlideGlosa from './AlertDialogSlideGlosa.jsx';
import DialogErrosValidacao from './DialogErrosValidacao.jsx';
import DrawerGuiaOriginal from './DrawerGuiaOriginal.jsx';
import DrawerGuiaSolicitacao from './DrawerGuiaSolicitacao.jsx';
import FormDialogCarencia from './FormDialogCarencia.jsx';
import LinearProgressBlockScreen from './LinearProgressBlockScreen.jsx';
import PainelElementos from './PainelElementos.jsx';
import VariantSnackbar from './VariantSnackbar.jsx';

const styles = theme => ({
  guiaContainer: {
    display: 'block',
    overflow: 'auto',
    flexGrow: 1,
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(1)
  },
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1)
  },
  iconParecer: {
    fontSize: 14,
    marginRight: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 11,
  },
  labelDadosInternacao: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(1),
  },
  labelDetalhe: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  labelMotivoRecurso: {
    // display: 'inline',
    color: theme.palette.secondary.main,
    // marginTop: theme.spacing(4),
    fontSize: 11,
  },
  labelDetalheParecer: {
    fontSize: 11,
    fontWeight: 'bold',
    maxWidth: theme.spacing(40),
  },
  selectTipoAtendimento: {
    marginTop: theme.spacing(-2.8),
  },
  buttonParecer: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(-1),
  },
  gridItemGuia: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(32),
    maxWidth: theme.spacing(32),
  },
  gridItemGuiaLarge: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(64),
    maxWidth: theme.spacing(64),
  },
  typographySelect: {
    userSelect: 'text',
    cursor: 'text'
  }
});

class Guia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      guia: undefined,
      carencias: [],
      isDetalhesCarregado: false,
      elementos: [],
      isElementosCarregado: false,
      openCarencias: false,
      guiaOriginal: {},
      guiasSolicitacao: [],
      detalhesGuia: {},
      operacao: {
        clickedButton: '',
        dialog: {
          open: false,
          title: '',
          message: '',
        },
      },
      openDialogGlosaGuia: false,
      dialogOpenErrosValidacao: false,
      dialogContent: [],
      dialogTitle: [],
      // expanded: false,
      anchorElVertMenu: null,
      snackOpen: false,
      guiasSolicitacaoOpen: false,
      openDialogHistorico: false,
      tituloFormDialog: '',
      tiposDeAtendimento: [],
      desTipoAtendimentoSelected: undefined,
      codTipoAtendimentoSelected: undefined,
      codTipoAtendimentoPrev: undefined,
      edicaoTipoAtendimento: false,

      caraterSolicitacao: [],
      codCaraterSolicitacaoSelected: undefined,
      desCaraterSolicitacaoSelected: undefined,
      codCaraterSolicitacaoPrev: undefined,
      edicaoCaraterSolicitacao: false,

      edicaoParecer: false,
      txtParecer: '',
      txtParecerButton: '',
      anchorElVertMenu: null,
      openCarencias: false,
    };
  }

  elementoApi = new ElementoApi();
  guiaApi = new GuiaApi();
  carenciaApi = new CarenciaApi();
  utils = new Utils();
  guiaApi = new GuiaApi();
  tipoDeAtendimentoApi = new TipoAtendimentoApi();
  beneficiarioApi = new BeneficiarioApi();


  componentDidMount = async () => {
    console.log('chegou na guia original');
    if (this.props.guia !== undefined) {

      const guiaSelecionada = this.props.guia;
      const carencias = await this.consultarCarencias(guiaSelecionada.numCarteiraTst) || [];
      const newElementos = await this.consultarElementosDaGuia(guiaSelecionada) || [];
      const newDetalhesGuia = await this.consultarDetalhesGuia(guiaSelecionada) || {};
      const tiposDeAtendimento = await this.tipoDeAtendimentoApi.consultarTiposAtendimento();
      const caraterSolicitacao = await this.tipoDeAtendimentoApi.consultarCaraterSolicitacao();

      this.setState({
        guia: guiaSelecionada,
        carencias: carencias,
        detalhesGuia: newDetalhesGuia,
        codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
        codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,

        caraterSolicitacao: caraterSolicitacao,
        codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
        desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
        codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,

        txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
        txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
        isDetalhesCarregado: true,
        tiposDeAtendimento: tiposDeAtendimento,
        elementos: newElementos,
        isElementosCarregado: true,
      });
    }
  }

  consultarElementosDaGuia = async ({ codLoteGuia, codGuia }) => {
    const newElementos = await this.elementoApi.consultarElementosDaGuia(codLoteGuia, codGuia);
    return newElementos || [];
  }

  consultarDetalhesGuia = async ({ codLoteGuia, codGuia, codTipoGuia }) => {
    const detalhesGuia = await this.guiaApi.consultarDetalhesGuia(codGuia, codLoteGuia, codTipoGuia);
    // const detalhesGuia = {
    //   "codCaraterSolicitacao": "1",
    //   "codGuia": 3475686,
    //   "codTipoAtendimento": 5,
    //   "codUfRegistroExecutante": "SP",
    //   "codUfRegistroSolicitante": "DF",
    //   "desCaraterSolicitacao": "Eletiva",
    //   "desIndAcidente": "Não",
    //   "desTipoAtendimento": "Exames",
    //   "desTipoSaidaSpsadt": "Encerramento Administrativo",
    //   "dtaHoraAtendimento": "2024-05-17T14:30:00",
    //   "nomConselhoExecutante": "Conselho Regional de Medicina (CRM)",
    //   "nomConselhoSolicitante": "Conselho Regional de Medicina (CRM)",
    //   "nomPrestadorExecutante": "PERFECTA DIAGNOSTICO POR IMAGEM LTDA",
    //   "nomProfissionalExecutante": "DR. JOÃO SILVA",
    //   "nomProfissionalSolicitante": "CICILIA LUIZA ROCHA DOS SANTOS PAIVA",
    //   "nomSolicitante": "PERFECTA DIAGNOSTICO POR IMAGEM",
    //   "numCnpjExecutante": 38020020000105,
    //   "numCpfCnpjSolicitante": "38020020000105",
    //   "numCpfExecutante": "12345678900",
    //   "numRegistroConselhoExecutante": "987654",
    //   "numRegistroConselhoSolicitante": "15510",
    //   "txtMotivoRecurso": "paciente realizou dos exames totalmente diferentes, um exame de axilas e outro de us PAREDE ABDOMINAL; Seguem anexos comprovantes dos exames.",
    //   "txtObservacao": "Paciente sem histórico de alergias. Internação para realização de exames de rotina.",
    //   "txtParecerAuditoria": "Aprovado sem ressalvas.",
    //   "nomExecutante": "PERFECTA DIAGNOSTICO POR IMAGEM",
    //   "dtaHoraAtedimento": "2024-05-17T14:30:00",
    //   "desTipoConsulta": "Consulta de Rotina",
    //   "dataHora": "2024-05-17T14:30:00",
    //   "txtTipoAcomodacao": "Enfermaria",
    //   "txtTipoInternacao": "Cirúrgica",
    //   "txtRegimeInternacao": "Integral",
    //   "dataHoraSaida": "2024-05-17T17:00:00",
    //   "desDiagnosticoPrincipal": "Cisto simples de ovário",
    //   "desDiagnosticoSec1": "Hipertensão arterial",
    //   "desDiagnosticoSec2": "Diabetes mellitus tipo 2",
    //   "desDiagnosticoSec3": "Nenhum"
    // }
    return detalhesGuia || {};
  }

  consultarCarencias = async (numMatricula) => {
    const carencias = await this.carenciaApi.consultarPorCarteira(numMatricula);
    return carencias || [];
  }

  componentDidUpdate = async (prevProps, prevState) => {

    if (this.props.guia !== undefined) {
      if (prevProps.codGuia !== this.props.codGuia) {
        let guiaSelecionada = this.props.guia;
        this.setState({
          guia: guiaSelecionada, elementos: [],
          isElementosCarregado: false,
          detalhesGuia: {},
          isDetalhesCarregado: false,
          edicaoCaraterSolicitacao: false,
          edicaoTipoAtendimento: false,
          edicaoParecer: false
        });
      }
    }

    if (prevState.guia !== undefined) {

      if (prevState.guia.codGuia !== this.state.guia.codGuia) {
        this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
        let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
        let newElementos = await this.consultarElementosDaGuia(this.state.guia);
        let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
        this.setState({
          elementos: newElementos,
          isElementosCarregado: true,
          detalhesGuia: newDetalhesGuia,
          codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
          codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
          codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
          desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
          codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
          txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
          txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
          isDetalhesCarregado: true,
          carencias: carencias
        });
        this.props.hideLoading();
      }
      
      if (prevState.guia.valTotalLiberado !== this.state.guia.valTotalLiberado ||
          prevState.guia.valTotalGlosado !== this.state.guia.valTotalGlosado) {
            this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
            let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
            let newElementos = await this.consultarElementosDaGuia(this.state.guia);
            let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
            this.setState({
              elementos: newElementos,
              isElementosCarregado: true,
              detalhesGuia: newDetalhesGuia,
              codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
              codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
              codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
              desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
              codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
              txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
              txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
              isDetalhesCarregado: true,
              carencias: carencias
            });
            this.props.hideLoading();
      }
        
      if (prevState.guia.qtdeElementosJaAuditados !== this.state.guia.qtdeElementosJaAuditados) {
        this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
        let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
        let newElementos = await this.consultarElementosDaGuia(this.state.guia);
        let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
        this.setState({
          elementos: newElementos,
          isElementosCarregado: true,
          detalhesGuia: newDetalhesGuia,
          codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
          codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
          codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
          desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
          codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
          txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
          txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
          isDetalhesCarregado: true,
          carencias: carencias
        });
        this.props.hideLoading();
      }
      


      // if (prevState.guia.codGuia !== this.state.guia.codGuia ||
      //   prevState.guia.valTotalLiberado !== this.state.guia.valTotalLiberado ||
      //   prevState.guia.valTotalGlosado !== this.state.guia.valTotalGlosado ||
      //   prevState.guia.qtdeElementosJaAuditados !== this.state.guia.qtdeElementosJaAuditados) {
        
      //     console.log('guia mudou. ', prevState.guia.codGuia, this.state.guia);
        
        // this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
        // let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
        // let newElementos = await this.consultarElementosDaGuia(this.state.guia);
        // let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
        // this.setState({
        //   elementos: newElementos,
        //   isElementosCarregado: true,
        //   detalhesGuia: newDetalhesGuia,
        //   codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
        //   codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
        //   codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
        //   desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
        //   codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
        //   txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
        //   txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
        //   isDetalhesCarregado: true,
        //   carencias: carencias
        // });
        // this.props.hideLoading();
      // }
    }
  }

  updateGuia = async () => {
    // console.log('como houve alteracao em um elemento da guia vou chamar o updateGuia');
    const newGuiaSelecionada = await this.guiaApi.consultarGuia(this.state.guia.codLoteGuia, this.state.guia.codGuia);
    const newElementos = await this.consultarElementosDaGuia(newGuiaSelecionada);
    this.setState({ guia: newGuiaSelecionada, elementos: newElementos });
    await this.props.onOperacaoRealizada();
  }

  handleConfirmDialogOperacao = async () => {
    const { clickedButton, dialog } = this.state.operacao;
    const { guia } = this.state;
    let result;

    this.setState({
      operacao: {
        dialog: { open: false, title: dialog.title, message: dialog.message },
        clickedButton: clickedButton
      },
    });

    if (clickedButton === 'desfazer') {
      this.props.showLoading('Desfazendo auditoria da guia..');
      result = await this.guiaApi.desfazerAuditoria(guia.codLoteGuia, guia.codGuia);
      await this.onOperacaoFinalizadaGuia(result);
      this.props.hideLoading();
    } else if (clickedButton === 'automatica') {
      this.props.showLoading('Realizando auditoria automática..');
      result = await this.guiaApi.auditarAutomaticamente(guia.codLoteGuia, guia.codGuia);
      await this.onOperacaoFinalizadaGuia(result);
      this.props.hideLoading();
    } else if (clickedButton === 'autorizar') {
      this.props.showLoading('Autorizando itens da guia..');
      result = await this.guiaApi.autorizar(guia.codLoteGuia, guia.codGuia);
      await this.onOperacaoFinalizadaGuia(result);
      this.props.hideLoading();
    } else if (clickedButton === 'glosar') {
      this.handleAdicionarGlosaGuia();
    }
  }

  handleCloseDialogOperacao = () => {
    this.setState({ operacao: { dialog: { open: false } } });
  }

  onOperacaoFinalizadaGuia = async (result) => {
    if (result !== undefined) {
      if (result.data.codigoRetorno === 1) {
        await this.updateGuia();
        this.props.showSnackbar(result.data.msgRetornoResumida, 'success', 3000, '', null, 'bottom');
      } else {
        this.setState({
          dialogOpenErrosValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          lotesSemErros: result.data.registrosSemErros
        });
      }
    } else if (result === undefined || result.data === undefined) {
      this.props.showSnackbar(`Não foi possível realizar a operação.`, 'error', 3000, '', null, 'bottom');
    }
  }

  handleAdicionarGlosaGuia = async () => {
    this.setState({ openDialogGlosaGuia: true });
  }

  handleCloseDialogGlosaGuia = () => {
    this.setState({ openDialogGlosaGuia: false });
  }

  handleCloseDialogErrosValidacao = async () => {
    this.setState({ dialogOpenErrosValidacao: false });
    await this.updateGuia();
  }

  handleSaveGuiaConferida = async () => {
    const { guia } = this.state;
    await this.guiaApi.salvarGuiaConferida(guia.codLoteGuia, guia.codGuia);
    await this.updateGuia();
  }

  handleConfirmDialogGlosaGuia = async (codMensagemGlosa, desMensagemGlosa, desObservacao) => {
    this.setState({ openDialogGlosaGuia: false });
    this.props.showLoading('Glosando itens da guia..');
    let { guia } = this.state;
    let glosaJaExiste = false;
    let glosaAtual = {
      codMensagemGlosa: codMensagemGlosa,
      desMensagemGlosa: desMensagemGlosa,
      txtObservacao: desObservacao
    };
    for (let i = 0; i < guia.glosas.length; i++) {
      if (guia.glosas[i].codMensagemGlosa === codMensagemGlosa) {
        glosaJaExiste = true;
        guia.glosas[i].txtObservacao = glosaAtual.txtObservacao;
        break;
      }
    }

    if (!glosaJaExiste) {
      guia.glosas.push(glosaAtual);
    }

    guia.dtaEmissao = null;
    guia.dtaRecebimento = null;
    guia.historico = [];
    await this.guiaApi.salvarMotivoGlosaGuia(guia);
    const result = await this.guiaApi.glosar(guia.codLoteGuia, guia.codGuia);

    await this.onOperacaoFinalizadaGuia(result);
    this.props.hideLoading();
  }

  todasAsGuiasEstaoNaoAnalisadas = () => {
    let todasAsGuiasEstaoNaoAnalisadas = true;
    this.state.guias.map(guiaDoLote => {
      if (guiaDoLote.codEstadoGuia !== 1) {
        todasAsGuiasEstaoNaoAnalisadas = false;
      }
    });
    return todasAsGuiasEstaoNaoAnalisadas;
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  handleChangeSelectTipoAtendimento = event => {
    this.setState({ [event.target.name]: event.target.value, edicaoTipoAtendimento: true });
  }
  handleChangeSelectCaraterSolicitacao = event => {
    this.setState({ [event.target.name]: event.target.value, edicaoCaraterSolicitacao: true });
  }

  handleChangeParecer = event => {
    this.setState({ [event.target.name]: event.target.value.toUpperCase() });
  }

  handleClickFecharEdicaoParecer = () => {
    this.setState({ edicaoParecer: false, txtParecer: '' });
  }

  handleClickParecer = () => {
    this.setState({ edicaoParecer: !this.state.edicaoParecer && this.props.emAuditoria });
  }

  handleSaveTipoAtendimento = async () => {
    let encontrouElementoSemInternacao = false;
    if (this.state.codTipoAtendimentoSelected === 6 || this.state.codTipoAtendimentoSelected === 7) {
      for (var i = 0; i < this.state.elementos.length; i++) {
        let isInternado = await this.beneficiarioApi.consultarBeneficiarioInternado(this.props.guia.numCarteiraTst,
          parse(this.state.elementos[i].dtaRealizacao));
        if (isInternado === 'N') {
          encontrouElementoSemInternacao = true;
          break;
        }
      }
    }
    if (!encontrouElementoSemInternacao) {
      await this.tipoDeAtendimentoApi.alterarTipoAtendimentoSpsadt(this.props.guia.codLoteGuia, this.props.guia.codGuia, this.props.guia.codTipoGuia, this.state.codTipoAtendimentoSelected);
      this.setState({ codTipoAtendimentoPrev: this.state.codTipoAtendimentoSelected });
    } else {
      this.props.showSnackbar('Favor cadastrar uma internação para este beneficiário que englobe todos os elementos da guia', 'error', 3000, '', null, 'bottom');
      this.setState({ codTipoAtendimentoSelected: this.state.codTipoAtendimentoPrev });
    }
    this.setState({ edicaoTipoAtendimento: false });
  }

  handleSaveCaraterSolicitacao = async () => {
    await this.tipoDeAtendimentoApi.alterarCaraterSolicitacao(
      this.props.guia.codLoteGuia, this.props.guia.codGuia,
      this.props.guia.codTipoGuia, this.state.codCaraterSolicitacaoSelected);

    this.setState({ codCaraterSolicitacaoPrev: this.state.codCaraterSolicitacaoSelected, edicaoCaraterSolicitacao: false });
  }

  handleClickFecharEdicaoTipoAtendimento = () => {
    this.setState({ edicaoTipoAtendimento: false, codTipoAtendimentoSelected: undefined });
  }

  handleClickFecharEdicaoCaraterSolicitacao = () => {
    this.setState({ edicaoCaraterSolicitacao: false, codCaraterSolicitacaoSelected: undefined });
  }

  handleSaveParecer = async () => {
    await this.guiaApi.salvarParecerAuditoria(this.props.guia.codLoteGuia, this.props.guia.codGuia, this.state.txtParecer);
    this.setState({ edicaoParecer: false, txtParecerButton: this.state.txtParecer });
  }

  handleCarenciasOpen = () => {
    this.setState({ openCarencias: true });
  }

  handleCloseCarencia = () => {
    this.setState({ openCarencias: false });
  }

  handleOpenVertMenu = event => {
    this.setState({ anchorElVertMenu: event.currentTarget });
  }

  handleCloseVertMenu = () => {
    this.setState({ anchorElVertMenu: null });
  }

  handleClickGuiaOriginal = async () => {
    this.props.showLoading('Carregando guia original..');
    const guiaOriginal = await this.guiaApi.consultarGuiaOriginal(this.props.guia.codGuiaRecorrida, 0);
    this.setState({ guiaOriginal: guiaOriginal, guiaOriginalOpen: true });
    this.props.hideLoading();
  }

  handleClickGuiasSolicitacao = async () => {
    this.props.showLoading('Carregando guias de solicitacao..');
    const guiasSolicitacao = await this.guiaApi.consultarGuiasSolicitacao(this.props.guia.codLoteGuia, this.props.guia.txtSenhaAutorizacao, this.props.guia.numCarteiraTst);
    console.log(guiasSolicitacao);
    this.props.hideLoading();
    if (guiasSolicitacao.length <= 0) {
      this.setState({ guiasSolicitacao: [], guiasSolicitacaoOpen: false, snackOpen: true });
    } else {
      this.setState({ guiasSolicitacao: guiasSolicitacao, guiasSolicitacaoOpen: true, snackOpen: false });
    }
  }

  handleCloseGuiaOriginal = () => {
    this.props.setGuiaOriginal({});
    this.setState({ guiaOriginal: {}, guiaOriginalOpen: false });
  }

  handleCloseGuiasSolicitacao = () => {
    this.setState({ guiasSolicitacao: {}, guiasSolicitacaoOpen: false });
  }

  handleClickOperacao = (id, dialogTitle, dialogMessage) => {
    const operacao = {
      clickedButton: id,
      dialog: {
        open: true,
        title: dialogTitle,
        message: dialogMessage
      }
    };
    this.setState({
      operacao: operacao,
    });
    this.handleCloseVertMenu();
  }

  conselhoProfissional = (input) => {
    if (input !== undefined && input !== null) {
      var inicio = input.indexOf('(');
      var fim = input.indexOf(')');
      if (inicio && fim) {
        return input.substring(inicio + 1, fim);
      } else {
        return input;
      }
    }
  }
  handleInnerElementClick = (event) => {
    event.stopPropagation();
    // Handle the element's specific action here
    console.log('Element inside accordion header clicked');
  };

  render() {
    const { classes, readOnly, emAuditoria } = this.props;

    const { guia, isDetalhesCarregado, detalhesGuia, detalhesGuiaOriginal, isElementosCarregado, anchorElVertMenu, carencias } = this.state;
    
    const open = Boolean(anchorElVertMenu);

    return (      
      guia !== undefined ?
        <React.Fragment>
          <div className={classes.guiaContainer}>
            {isDetalhesCarregado && (detalhesGuia !== undefined || detalhesGuiaOriginal !== undefined) ?
              <div className={classes.root}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <Grid container direction="row" justifyContent='space-between' alignItems='center'>
                      <Grid item  onClick={this.handleInnerElementClick}>
                        <Typography variant='h6' className={classes.typographySelect}>
                          {guia.qtdeElementosJaAuditados && guia.qtdeElementos ? guia.qtdeElementosJaAuditados + '/' + guia.qtdeElementos : ''} • {guia.nomeBeneficiario} • {guia.numCarteiraTst}
                          <Typography inline fontStyle='italic' variant='caption'>{'  ' + format(guia.dtaRecebimento, 'DD/MM/YYYY')}</Typography>
                        </Typography>
                      </Grid>
                      <Grid item>
                        <ButtonHistoricoGuia historico={this.state.guia.historico} />
                        {this.state.guia.anexos && 
                        <ButtonAnexos
                          title={['Anexos da guia ', this.state.guia.numGuiaPrestador]}
                          anexos={this.state.guia.anexos}
                        />}
                        {this.state.guia.glosas && <ButtonGlosas
                          title={['Glosas da guia ', this.state.guia.numGuiaPrestador]}
                          glosas={this.state.guia.glosas}
                          emAuditoria={this.props.emAuditoria} />
                        }
                        {this.state.guia.alertas &&
                          <ButtonAlertas
                            title={['Alertas da guia ', this.state.guia.numGuiaPrestador]}
                            alertas={this.state.guia.alertas} />
                        }
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      container
                      direction='row'
                      spacing={4}
                      justifyContent='flex-start'
                      alignItems='flex-start'>
                      {guia.numGuiaPrestador || guia.numGuiaOperadora || guia.txtSenhaAutorizacao ?
                        <Grid item >
                          <Typography className={classes.label}>Nº Guia Prestador</Typography>
                          <Typography variant='button' title='Número da Guia do Prestador'>{guia.numGuiaPrestador}</Typography>
                          <Typography className={classes.label}>Nº Guia Operadora</Typography>
                          <Typography variant='button' title='Número da Guia da Operadora'>{guia.numGuiaOperadora}</Typography>
                          {guia.txtSenhaAutorizacao &&
                            <>
                              <Typography className={classes.label}>Senha: </Typography>
                              <Typography variant='button' title='Senha de Autorização'>{guia.txtSenhaAutorizacao}</Typography>
                            </>
                          }
                        </Grid>
                        : null}
                      <Grid item>
                        <Typography className={classes.label}>Valor processado</Typography>
                        <Box color="text.primary"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalProcessado)}</Typography></Box>
                        <Typography className={classes.label}>Valor glosado</Typography>
                        <Box color="warning.main"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalGlosado)}</Typography></Box>
                        <Typography className={classes.label}>Valor liberado</Typography>
                        <Box color="info.main"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalLiberado)}</Typography></Box>
                      </Grid>
                      <Grid item className={classes.gridItemGuia}>
                        {detalhesGuia.nomSolicitante
                          || detalhesGuia.nomProfissionalSolicitante
                          || detalhesGuia.nomPrestadorExecutante
                          || detalhesGuia.nomProfissionalExecutante
                          || detalhesGuia.numCpfCnpjExecutante ?
                          <>
                            <Typography className={classes.label}>Profissional solicitante</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Profissional solicitante'>
                              {detalhesGuia.nomProfissionalSolicitante ? detalhesGuia.nomProfissionalSolicitante : 'Não informado'}
                            </Typography>
                            <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='Conselho Profissional'>
                              {detalhesGuia.numRegistroConselhoSolicitante ? detalhesGuia.numRegistroConselhoSolicitante + ' - ' + this.conselhoProfissional(detalhesGuia.nomConselhoSolicitante) + ' ' + detalhesGuia.codUfRegistroSolicitante : '-'}
                            </Typography>
                            {detalhesGuia.nomSolicitante ?
                              <>
                                <Typography className={classes.label}>Prestador solicitante</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Prestador Solicitante'>{detalhesGuia.nomSolicitante}</Typography>
                                <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='CPF/CNPJ'>{this.utils.cpfOuCnpj(detalhesGuia.numCpfCnpjSolicitante)}</Typography>
                              </>
                              : null}
                            {detalhesGuia.nomProfissionalExecutante ?
                              <>
                                <Typography className={classes.label}>Profissional executante</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Profissional executante'>{detalhesGuia.nomProfissionalExecutante && detalhesGuia.numRegistroConselhoExecutante ? detalhesGuia.nomProfissionalExecutante : 'Não informado'}</Typography>
                                <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='Conselho Profissional'>
                                  {detalhesGuia.nomProfissionalExecutante && detalhesGuia.numRegistroConselhoExecutante
                                    ? detalhesGuia.numRegistroConselhoExecutante + ' - ' + this.conselhoProfissional(detalhesGuia.nomConselhoExecutante) + ' ' + detalhesGuia.codUfRegistroExecutante : null}
                                </Typography>
                              </>
                              : null}
                            <>
                              <Typography className={classes.label}>Prestador executante</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Prestador executante'>
                                {detalhesGuia.nomPrestadorExecutante ? detalhesGuia.nomPrestadorExecutante : (detalhesGuia.nomExecutante ? detalhesGuia.nomExecutante : 'Não informado')}
                              </Typography>
                              <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='CPF/CNPJ'>{this.utils.cpfOuCnpj(detalhesGuia.numCnpjExecutante)}</Typography>
                            </>
                          </>
                          : null}
                      </Grid>
                      {detalhesGuia.desTipoAtendimento
                        ?
                        <Grid item className={classes.gridItemGuia}>
                          <>
                            <Typography className={classes.label}>Tipo atendimento</Typography>
                            { readOnly ? (
                              <Typography className={classes.labelDetalhe} variant='button' title='Tipo Atendimento'>
                                {detalhesGuia.desTipoAtendimento}
                              </Typography>)
                            :
                            <>
                              <br />
                              <TextField
                                select
                                className={classes.selectTipoAtendimento}
                                value={this.state.codTipoAtendimentoSelected !== undefined ? this.state.codTipoAtendimentoSelected : detalhesGuia.codTipoAtendimento}
                                onChange={this.handleChangeSelectTipoAtendimento}
                                InputProps={{
                                  name: 'codTipoAtendimentoSelected',
                                  sx: { fontSize: 10 },
                                  endAdornment: this.state.edicaoTipoAtendimento &&
                                    <InputAdornment position='end'>
                                      <IconButton
                                        color='primary'
                                        disabled={this.state.edicaoTipoAtendimento === false}
                                        title='Salvar Tipo de Atendimento...'
                                        onClick={this.handleSaveTipoAtendimento}
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                      <IconButton
                                        color='secondary'
                                        disabled={this.state.edicaoTipoAtendimento === false}
                                        title='Fechar'
                                        onClick={this.handleClickFecharEdicaoTipoAtendimento}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </InputAdornment>,
                                }}
                              >
                                {this.state.tiposDeAtendimento.map((tipoAtendimento, idx) => {
                                  return (<MenuItem key={idx} value={tipoAtendimento.codTipoAtendimento}>{tipoAtendimento.desTipoAtendimento}</MenuItem>);
                                })}
                              </TextField>
                            </>
                            }

                            {detalhesGuia.dtaHoraAtendimento ?
                              <>
                                <Typography className={classes.label}>Data e hora de atendimento</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Data e hora de atendimento'>{format(detalhesGuia.dtaHoraAtendimento, 'DD/MM/YYYY')}</Typography>
                              </>
                              : null}
                            {detalhesGuia.desCaraterSolicitacao
                              ? <>
                                <Typography className={classes.label}>Caráter da Solicitação</Typography>
                                { readOnly ? (
                                  <Typography className={classes.labelDetalhe} variant='button' title='Tipo Atendimento'>
                                    {detalhesGuia.desCaraterSolicitacao}
                                </Typography>
                                ) : 
                              <>
                                <br />
                                <TextField
                                  select
                                  className={classes.selectTipoAtendimento}
                                  value={this.state.codCaraterSolicitacaoSelected !== undefined ? this.state.codCaraterSolicitacaoSelected : detalhesGuia.codCaraterSolicitacao}
                                  onChange={this.handleChangeSelectCaraterSolicitacao}
                                  InputProps={{
                                    name: 'codCaraterSolicitacaoSelected',
                                    endAdornment: this.state.edicaoCaraterSolicitacao &&
                                      <InputAdornment position='end'>
                                        <IconButton
                                          color='primary'
                                          disabled={this.state.edicaoCaraterSolicitacao === false}
                                          title='Salvar Caráter da Solicitação...'
                                          onClick={this.handleSaveCaraterSolicitacao}
                                        >
                                          <CheckIcon />
                                        </IconButton>
                                        <IconButton
                                          color='secondary'
                                          disabled={this.state.edicaoCaraterSolicitacao === false}
                                          title='Fechar'
                                          onClick={this.handleClickFecharEdicaoCaraterSolicitacao}
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                      </InputAdornment>,
                                  }}
                                >
                                  {this.state.caraterSolicitacao.map((carater, idx) => {
                                    return (<MenuItem key={idx} value={carater.id}>{carater.nome}</MenuItem>);
                                  })}
                                </TextField>
                              </>  
                              }
                              </>
                              : null}
                            {detalhesGuia.desTipoSaidaSpsadt
                              ? <>
                                <Typography className={classes.label}>Tipo de Saída</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Tipo de Saída'>{`Saída por ${detalhesGuia.desTipoSaidaSpsadt}`}</Typography>
                              </>
                              : null}
                          </>
                        </Grid>
                        : null}
                      <Grid item>
                        {detalhesGuia.desTipoConsulta
                          ? <>
                            <Typography className={classes.label}>Tipo da Consulta</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Tipo da Consulta'>{detalhesGuia.desTipoConsulta}</Typography>
                          </>
                          : null}
                        {detalhesGuia.desIndAcidente
                          ? <>
                            <Typography className={classes.label}>Tipo de Acidente</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Tipo de Acidente'>{detalhesGuia.desIndAcidente}</Typography>
                          </>
                          : null}
                      </Grid>
                      {detalhesGuia.dataHora
                        ?
                        <Grid item className={classes.gridItemGuia}>
                          {detalhesGuia.desCaraterSolicitacao &&
                            <>
                              <Typography className={classes.labelDadosInternacao}>DADOS DA INTERNAÇÃO:</Typography>
                              <Typography className={classes.label}>Caráter da Solicitação</Typography>
                              <br />
                              <TextField
                                select
                                className={classes.selectTipoAtendimento}
                                value={this.state.codCaraterSolicitacaoSelected !== undefined ? this.state.codCaraterSolicitacaoSelected : detalhesGuia.codCaraterSolicitacao}
                                onChange={this.handleChangeSelectCaraterSolicitacao}
                                InputProps={{
                                  name: 'codCaraterSolicitacaoSelected',
                                  endAdornment: this.state.edicaoCaraterSolicitacao &&
                                    <InputAdornment position='end'>
                                      <IconButton
                                        color='primary'
                                        disabled={this.state.edicaoCaraterSolicitacao === false}
                                        title='Salvar Caráter da Solicitação...'
                                        onClick={this.handleSaveCaraterSolicitacao}
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                      <IconButton
                                        color='secondary'
                                        disabled={this.state.edicaoCaraterSolicitacao === false}
                                        title='Fechar'
                                        onClick={this.handleClickFecharEdicaoCaraterSolicitacao}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </InputAdornment>,
                                }}
                              >
                                {this.state.caraterSolicitacao.map((carater, idx) => {
                                  return (<MenuItem key={idx} value={carater.id}>{carater.nome}</MenuItem>);
                                })}
                              </TextField>
                            </>}
                          {detalhesGuia.txtTipoAcomodacao &&
                            <>
                              <Typography className={classes.label}>Tipo da Acomodação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title=''>{detalhesGuia.txtTipoAcomodacao}</Typography>
                            </>
                          }
                          {detalhesGuia.txtTipoInternacao &&
                            <>
                              <Typography className={classes.label}>Tipo da Internação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Tipo da Internação'>{detalhesGuia.txtTipoInternacao}</Typography>
                            </>
                          }{detalhesGuia.txtRegimeInternacao &&
                            <>
                              <Typography className={classes.label}>Regime da Internação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Regime da Internação'>{detalhesGuia.txtRegimeInternacao}</Typography>
                            </>
                          }
                          <>
                            <Typography className={classes.label}>Data e hora</Typography>
                            <Box fontStyle="italic" >
                              <Typography variant="caption" title='Entrada'>{`${format(detalhesGuia.dataHora, 'DD/MM/YYYY HH:mm:ss')}`}</Typography>
                              <Typography variant="caption" title='Saída'>{` a ${format(detalhesGuia.dataHoraSaida, 'DD/MM/YYYY HH:mm:ss')}`}</Typography>
                            </Box>
                          </>
                        </Grid>
                        : null}
                      {detalhesGuia.desDiagnosticoPrincipal
                        ? <Grid item className={classes.gridItemGuia}>
                          <>
                            <Typography className={classes.label}>Diagnósticos</Typography>
                            <Typography className={classes.labelDetalhe} title='Diagnóstico Principal'>{detalhesGuia.desDiagnosticoPrincipal}</Typography>
                          </>

                          {detalhesGuia.desDiagnosticoSec1
                            ? <>
                              <Typography className={classes.label}>1º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='1º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec1}</Typography>
                            </>
                            : null}
                          {detalhesGuia.desDiagnosticoSec2
                            ? <>
                              <Typography className={classes.label}>2º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='2º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec2}</Typography>
                            </>
                            : null}
                          {detalhesGuia.desDiagnosticoSec3
                            ? <>
                              <Typography className={classes.label}>3º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='3º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec3}</Typography>
                            </>
                            : null}
                        </Grid>
                        : null}
                      {detalhesGuia.txtObservacao || detalhesGuia.txtMotivoRecurso
                        ? <Grid item className={classes.gridItemGuiaLarge}>
                          {detalhesGuia.txtObservacao
                            ? <>
                              <Typography className={classes.label}>Observação</Typography>
                              <Typography className={classes.labelDetalhe} title='Observação enviada pelo prestador'>{detalhesGuia.txtObservacao}</Typography>
                            </>
                            : null}

                          {detalhesGuia.txtMotivoRecurso
                            ? <>
                              <Typography className={classes.labelMotivoRecurso}>Motivo do Recurso</Typography>
                              <Typography className={classes.labelDetalhe} title='Motivo do Recurso'>{detalhesGuia.txtMotivoRecurso}</Typography>
                            </>
                            : null}
                        </Grid>
                        : null}
                      {detalhesGuia.nomSolicitante
                        || detalhesGuia.nomProfissionalSolicitante
                        || detalhesGuia.nomPrestadorExecutante
                        || detalhesGuia.nomProfissionalExecutante
                        || detalhesGuia.numCpfCnpjExecutante ?

                        <Grid item className={classes.gridItemGuiaLarge}>
                          {readOnly ? (
                          <>
                            <Button
                              size='small'
                              className={classes.buttonParecer}
                              onClick={this.handleClickParecer}
                              disabled>
                              <EditIcon size='small' className={classes.iconParecer} />
                              Parecer da auditoria
                            </Button>
                            <Typography className={classes.labelDetalheParecer} title='Parecer da auditoria'>
                              {this.state.txtParecer}
                              </Typography>
                          </>)
                          :
                            <>
                            <Button
                            size='small'
                            className={classes.buttonParecer}
                            onClick={this.handleClickParecer}
                            disabled={!this.props.emAuditoria}>
                            <EditIcon size='small' className={classes.iconParecer} />
                            Parecer da auditoria
                          </Button>
                          <Typography className={classes.labelDetalheParecer} title='Parecer da auditoria'>{this.state.txtParecer}</Typography>

                          {this.state.edicaoParecer && this.props.emAuditoria &&
                            <TextField
                              error={this.state.txtParecer.length > 1000}
                              multiline
                              autoFocus
                              maxRows='8'
                              fullWidth
                              value={this.state.txtParecer}
                              onChange={this.handleChangeParecer}
                              helperText='(max. 1.000 caracteres)'
                              variant='filled'
                              InputProps={{
                                name: 'txtParecer',
                                maxLength: 1000,
                                endAdornment: <InputAdornment position='end'>
                                  <IconButton
                                    color='primary'
                                    title='Salvar Parecer...'
                                    disabled={this.state.txtParecer === '' || this.state.txtParecer.length > 1000}
                                    onClick={this.handleSaveParecer}
                                  >
                                    <CheckIcon />
                                  </IconButton>
                                  <IconButton
                                    color='secondary'
                                    title='Fechar'
                                    onClick={this.handleClickFecharEdicaoParecer}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </InputAdornment>,
                              }}
                            />
                          }
                            </>
                          }



                        </Grid>
                        : null}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
              : readOnly ?
                null : <LinearProgress />
            }
            {isElementosCarregado && this.state.elementos !== undefined
              ? <PainelElementos
                elementos={this.state.elementos}
                onOperacaoRealizada={this.updateGuia}
                emAuditoria={emAuditoria}
                exibirFiltros={true}
                readOnly={readOnly}
                isGuiaSolicitacao={false} />
              : <LinearProgress />
            }
          </div>

          {this.state.dialogOpenErrosValidacao &&
            <DialogErrosValidacao
              open={this.state.dialogOpenErrosValidacao}
              handleClose={this.handleCloseDialogErrosValidacao}
              erros={this.state.dialogContent}
              titulo={this.state.dialogTitle}
            />}

          {this.state.guiaOriginalOpen &&
            <DrawerGuiaOriginal
              open={this.state.guiaOriginalOpen}
              guiaOriginal={this.state.guiaOriginal}
              handleClose={this.handleCloseGuiaOriginal}
            />}

          {(this.state.guiasSolicitacaoOpen) &&
            <DrawerGuiaSolicitacao
              open={this.state.guiasSolicitacaoOpen}
              guiasSolicitacao={this.state.guiasSolicitacao}
              handleClose={this.handleCloseGuiasSolicitacao}
            />}

          <VariantSnackbar
            vertical={'top'}
            horizontal={'right'}
            variant={'warning'}
            message={'Não foi encontrada uma guia de solicitação para esta senha'}
            open={this.state.snackOpen}
            duration={3000}
            handleClose={this.handleCloseSnackbar}
          />

          {this.state.openDialogGlosaGuia &&
            <AlertDialogSlideGlosa
              open={this.state.openDialogGlosaGuia}
              handleClose={this.handleCloseDialogGlosaGuia}
              handleClickIncluirGlosa={this.handleConfirmDialogGlosaGuia}
              title={'Adicionar motivo de glosa da guia'}
              message={''} />}

          {this.state.openCarencias &&
            <FormDialogCarencia
              open={this.state.openCarencias}
              handleClose={this.handleCloseCarencia}
              carencias={this.state.carencias} />}

          <AlertDialogSlide
            open={this.state.operacao.dialog.open}
            handleClose={this.handleCloseDialogOperacao}
            handleClick={this.handleConfirmDialogOperacao}
            title={this.state.operacao.dialog.title}
            message={this.state.operacao.dialog.message} />
        </React.Fragment>
        : <LinearProgressBlockScreen />
    );
  }
}
export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(Guia))));
